import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { hashTag_thisweek } from "motw_core/Constants/constants";
import { NavigateTo } from "source/app/presentation/Routing/RouterNavigationTarget";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

const dreamAttributeRoutes: Record<string, EDA> = {
    board: EDA.board,
    buy: EDA.buy,
    decision: EDA.decision,
    direction: EDA.direction,
    fascination: EDA.fascination,
    important: EDA.important,
    inprogress: EDA.in_progress,
    prayer: EDA.prayer,
    reading: EDA.reading,
    problem: EDA.problem,
    unclean: EDA.unclean,
    waypoint: EDA.waypoint,
};

export function RouteDreams(elementId?: string) {
    const route = NormalizeRoute(elementId);
    const filters = GetDreamsRouteFilters(route);

    if (!filters) {
        return;
    }

    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (dreams) {
        dreams.setState(filters);
    }
}

export function NavigateToDreamsRoute(route: string) {
    NavigateTo(`/Dreams/${route}`);
}

function GetDreamsRouteFilters(route: string | undefined) {
    if (route === `today`) {
        return {
            ...clearedDreamFilters,
            onlyShowTodaysDreams: true,
        };
    }

    if (route === `adjacent`) {
        return {
            ...clearedDreamFilters,
            onlyShowAdjacentDreams: true,
            excludedAttributes: [EDA[EDA.waypoint]],
        };
    }

    if (route === `thisweek`) {
        return {
            ...clearedDreamFilters,
            searchText: hashTag_thisweek,
        };
    }

    if (route === `campaigns`) {
        return {
            ...clearedDreamFilters,
            onlyShowMasterDreams: true,
        };
    }

    if (route === `reviews` || route === `toreview`) {
        return {
            ...clearedDreamFilters,
            onlyShowDreamsToReview: true,
        };
    }

    if (route === `figuringout`) {
        return {
            ...clearedDreamFilters,
            searchText: `figure out`,
        };
    }

    const attribute = route ? dreamAttributeRoutes[route] : undefined;

    if (attribute !== undefined) {
        return {
            ...clearedDreamFilters,
            selectedAttributes: [EDA[attribute]],
        };
    }

    if (route === `all`) {
        return clearedDreamFilters;
    }

    return undefined;
}

function NormalizeRoute(route?: string) {
    return route?.toLowerCase().replace(/[\s_-]/g, ``);
}
